import React, { useCallback } from 'react';
import { BalanceIcon } from '../assets/svg/PaymentStatus/StatusIcon';
import { renderDescriptionParagraphs } from '@rb-serve-app/core';

interface ToolTipProps {
  label?: string;
  tooltipText: string;
  gap?: string;
  labelColor?: string;
  labelSize?: string;
  labelWeight?: string;
  fill?: string;
  display?: string;
  isVisible: boolean;
  onToggle?: () => void;
  extraStyle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  index?: any;
  toolTipStyle?: React.CSSProperties;
}

const CommanToolTip: React.FC<ToolTipProps> = ({
  label,
  tooltipText,
  gap = '0',
  labelColor = 'text-[#1F1F1F]',
  labelSize = 'text-[15px]',
  labelWeight = 'font-normal',
  fill = '#2F6FA7',
  display = 'grid',
  isVisible,
  index,
  onToggle,
  extraStyle,
  toolTipStyle,
}) => {
  
  const gridBox =
  label
    ? `${display} items-center ${
        gap === '0' ? 'grid-cols-[1fr_auto]' : `gap-${gap}`
      }`
    : 'flex items-center';

  const handleOutsideClick = useCallback(
    (e: MouseEvent | TouchEvent) => {
      if (!(e.target as HTMLElement).closest('.tooltip-container')) {
        onToggle && onToggle();
      }
    },
    [onToggle]
  );
  const lang = localStorage.getItem('language');

  return (
    <div className={gridBox}>
      <span
        aria-label={label}
        className={`mr-2 ${labelColor} ${labelSize} ${labelWeight} ${extraStyle}`}
      >
        {label}
      </span>

      <div className="relative group tooltip-container" onClick={onToggle}>
        <span
          className="mt-1 inline-block cursor-pointer"
          aria-label="balanceIcon"
        >
          <BalanceIcon aria-label="Available credit icon" fill={fill} />
        </span>
        <div
          aria-label={renderDescriptionParagraphs(tooltipText, undefined, true)}
          className={`absolute bottom-full mb-1 hidden group-hover:block bg-gray-100 text-black text-xs rounded px-2 py-1 border border-gray-400 w-max font-[400]  max-w-[150px] z-[999]`}
          style={{
            ...toolTipStyle,
            right: index !== undefined ? '26px' : '',
            bottom:
              index === 0 && lang === 'fr'
                ? '-80px'
                : index === 0 || index === 1
                  ? '-60px'
                  : index === 2 || index === 3 || index === 4 || index === 5
                    ? '-40px'
                    : '',
          }}
        >
          {renderDescriptionParagraphs(tooltipText, undefined, true)}
        </div>
      </div>
    </div>
  );
};

export default CommanToolTip;
